import { render } from "./FormFile.vue?vue&type=template&id=30d9fa3b&scoped=true"
import script from "./FormFile.vue?vue&type=script&lang=js"
export * from "./FormFile.vue?vue&type=script&lang=js"

import "./FormFile.vue?vue&type=style&index=0&id=30d9fa3b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d9fa3b"]])

export default __exports__